var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressGood = function SvgAddressGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M15.481 17.926a1.5 1.5 0 1 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm15.96 8.019a1.5 1.5 0 0 1 2.269 1.963l-3.45 3.986a.5.5 0 0 1-.737.02l-2.37-2.453a1.5 1.5 0 1 1 2.157-2.085l.47.488 1.661-1.92zm-.96 9.981a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0 3c-5.799 0-10.5-4.7-10.5-10.5 0-5.799 4.701-10.5 10.5-10.5 5.8 0 10.5 4.701 10.5 10.5 0 5.8-4.7 10.5-10.5 10.5zM35.05 19.63h-3V13.5a1.5 1.5 0 0 0-1.5-1.5H12.5a1.5 1.5 0 0 0-1.5 1.5v5.985a1.5 1.5 0 0 0 1.5 1.5h11.3v3H12.5a4.5 4.5 0 0 1-4.5-4.5V13.5A4.5 4.5 0 0 1 12.5 9h18.05a4.5 4.5 0 0 1 4.5 4.5v6.13z"
  })));
};
export default SvgAddressGood;